import styled from "styled-components";

export const DoneContact = styled.form`
width: 65%;
margin: auto;
height: 100vh;
color: #ffffff;

display: flex;
flex-direction: column;
justify-content: center;
align-items: center;

border-radius: 5px;

background-color: transparent;


@media screen and (max-width: 600px) {
    width: 90%;
   
  }
`

